// @ts-nocheck

// ===================
// フォーカス可能な要素
// ===================
export const FOCUSABLE_ELEMENTS = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"])',
];

// ===================
// フォーカス制御
// ===================
export function handleFocus(focusableElements, checkConditionFn, event){
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
    if (event.code === "Tab" && checkConditionFn()) {
        if (event.shiftKey) {
            // Shift + Tab
            if (document.activeElement === firstFocusableElement) {
                event.preventDefault();
                // When on the first focusable element inside the dialog, focus the last one
                lastFocusableElement.focus();
            }
        } else {
            // Tab
            if (document.activeElement === lastFocusableElement) {
                event.preventDefault();
                // When on the last focusable element inside the dialog, focus the first one
                firstFocusableElement.focus();
            }
        }
    }
};
